
<template>
  <div style="height: 100%; width: 100%">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%; width: 100%;"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-control-attribution position="bottomright" :prefix="false"></l-control-attribution>

      <l-marker :lat-lng="markerLatLng" v-if="showMarker">
        <l-icon
        :icon-size="dynamicSize"
        :icon-anchor="dynamicAnchor"
        :icon-url="iconUrl"
        >
        </l-icon>
      </l-marker>
      <l-control-scale :imperial="false" position="bottomleft" />
    </l-map>
  </div>
</template>

<script>
import globals from '../../lib/globals';
import L, { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LControlAttribution, LControlScale } from "vue2-leaflet";

// TODO: default ikonit ei toimi, vue2leaflet juttuja...
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: "LeafletMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LControlAttribution,
    LControlScale
  },
  props: {
    address: {
      type: String,
      required: false,
    },
    coordinates: {
        type: String,
        default: null,
      },
    apiKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      zoom: 17,
      center: undefined,
      markerLatLng: undefined,
      //url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      url: `https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${this.apiKey}`,
      attribution:
            '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a>, ' +
            '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
      attributionControl: false,
      setPrefix: false,
      currentZoom: 11.5,
      currentCenter: undefined,
      mapOptions: {
        zoomSnap: 0.5
      },
      iconSize: [25,41],
      showMap: true,
      showMarker: false,
      iconUrl: `${globals.urlBase}/app/themes/avain/dist/images/vendor/leaflet/dist/marker-icon-2x.png`
    };
  },
  async created() {
    if(!this.coordinates) {
      console.log("no coordinates")
      const response = await fetch(`https://api.maptiler.com/geocoding/${this.address}.json?key=${this.apiKey}`);
      const data = await response.json();
      console.log(data)
      this.center = latLng(data.features[0].center[1], data.features[0].center[0])
      this.currentCenter = latLng(data.features[0].center[1], data.features[0].center[0])
      this.markerLatLng = latLng(data.features[0].center[1], data.features[0].center[0])
    } else {
      console.log("coordinates",this.coordinates)
      const coordinateArr = this.coordinates.split(" ").join("").split(',');

      this.center = latLng(coordinateArr[0]*1,coordinateArr[1]*1)
      this.currentCenter = latLng(coordinateArr[0]*1,coordinateArr[1]*1)
      this.markerLatLng = latLng(coordinateArr[0]*1,coordinateArr[1]*1)
    }
    this.showMarker = true;
  },
  mounted() {
    console.log("mount", this.address)

  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1];
    },
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
  }
};
</script>


<style lang="scss">
.leaflet-control-container .leaflet-bottom.leaflet-right {
  div:nth-child(2) {
    display: none;
  }
}
</style>
